/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AiQueryInteractionDto } from '../../models/ai-query-interaction-dto';
import { AiQueryRequest } from '../../models/ai-query-request';

export interface AiSessionsSessionIdAskPost$Plain$Params {
  sessionId: string;
      body?: AiQueryRequest
}

export function aiSessionsSessionIdAskPost$Plain(http: HttpClient, rootUrl: string, params: AiSessionsSessionIdAskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AiQueryInteractionDto>> {
  const rb = new RequestBuilder(rootUrl, aiSessionsSessionIdAskPost$Plain.PATH, 'post');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AiQueryInteractionDto>;
    })
  );
}

aiSessionsSessionIdAskPost$Plain.PATH = '/ai/sessions/{sessionId}/ask';
